import { css } from "@emotion/react";

export const styGallerySection = css`
  padding: 20px;
  text-align: center;
  color: #707e57;
  background-color: #f9f9f9;

  img {
    border-radius: 4px;
  }
`;
